import React from "react";
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";

export const AccessDenied = ({ module = "à ce module" }) => (
  <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="access-denied">
    <div className="text-center max-w-md">
      <div className="mx-auto h-14 w-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
        <ShieldOff className="h-7 w-7 text-slate-400" />
      </div>
      <h2 className="font-heading text-lg font-semibold text-slate-900 mb-1">Accès refusé</h2>
      <p className="text-sm text-slate-500 mb-5">
        Votre rôle ne vous donne pas accès {module}. Contactez le propriétaire du compte si vous pensez qu'il s'agit d'une erreur.
      </p>
      <Link
        to="/vendor/pilotage"
        className="inline-flex items-center gap-2 rounded-full bg-slate-900 text-white text-sm font-semibold px-5 py-2.5 hover:bg-slate-800 transition-colors"
        data-testid="access-denied-back-btn"
      >
        Retour au pilotage
      </Link>
    </div>
  </div>
);
